import React, { useState, Fragment, useRef } from "react";
import { getRandomVirtualBackground } from "../../common/utils";
import { HMSVirtualBackgroundPlugin } from "@100mslive/hms-virtual-background";
import { Tooltip, IconButton } from "@100mslive/react-ui";
import { store, useGlobalState } from "state-pool";
import {
  Button,
  useHMSStore,
  useHMSActions,
  MessageModal,
  ContextMenu,
  ContextMenuItem,
  VirtualBackgroundIcon,
  selectIsLocalVideoPluginPresent,
  ChangeTextIcon,
} from "@100mslive/hms-video-react";

import { fileOpen } from "browser-fs-access";
store.setState("vb", 0);
store.setState("previewPluginRef", 0);
store.setState("vbElement", 0);
export const PreviewVirtualBackgroundSetting = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [vb, setvb, updatevb] = useGlobalState("vb");
  const [showRecent, setShowRecent] = useState(false);
  const [vbElement, setvbElement, updatevbElement] =
    useGlobalState("vbElement");
  const [previewPluginRef, setpreviewPluginRef, updatepreviewPluginRef] =
    useGlobalState("previewPluginRef");

  const isVBPresent = useHMSStore(
    selectIsLocalVideoPluginPresent("@100mslive/hms-virtual-background")
  );

  const pluginRef = useRef(null);
  const hmsActions = useHMSActions();
  setpreviewPluginRef(pluginRef);

  let last_used = [];

  if (localStorage.getItem("last_used") === null) {
    localStorage.setItem("last_used", JSON.stringify(last_used));
  }

  function createVBPlugin() {
    if (!previewPluginRef.current) {
      previewPluginRef.current = new HMSVirtualBackgroundPlugin("none", true);
      setpreviewPluginRef(previewPluginRef.current);
    }
  }

  async function startPlugin(background) {
    //create plugin if not present
    createVBPlugin();
    window.HMS.virtualBackground = previewPluginRef.current;
    try {
      await previewPluginRef.current.setBackground(background);
      //Running VB on every alternate frame rate for optimized cpu usage
      await hmsActions.addPluginToVideoTrack(previewPluginRef.current, 15);
    } catch (err) {
      console.error("add virtual background plugin failed", err);
    }
  }

  async function removePlugin() {
    if (previewPluginRef.current) {
      await hmsActions.removePluginFromVideoTrack(previewPluginRef.current);
      previewPluginRef.current = null;
    }
  }

  async function handleblurVB() {
    await hmsActions.removePluginFromVideoTrack(previewPluginRef.current);
    previewPluginRef.current = null;
    setvb("blurr");
    startPlugin("blur");
  }

  function handleDisableVB() {
    removePlugin();
  }

  async function handleRandomVB() {
    await hmsActions.removePluginFromVideoTrack(previewPluginRef.current);
    previewPluginRef.current = null;
    let element = getRandomVirtualBackground();
    setvbElement(element.src);
    console.log(vbElement);
    setvb("random");
    startPlugin(element);
  }

  async function handleCustomVB() {
    const blob = await fileOpen({
      mimeTypes: ["image/*"],
      extensions: [".png", ".jpg", ".jpeg"],
    });

    const img = document.createElement("img");
    img.alt = "VB";
    img.src = URL.createObjectURL(blob);

    img.addEventListener(
      "load",
      function () {
        var imgCanvas = document.createElement("canvas"),
          imgContext = imgCanvas.getContext("2d");

        // Make sure canvas is as big as the picture
        imgCanvas.width = img.width;
        imgCanvas.height = img.height;

        // Draw image into canvas element
        imgContext.drawImage(img, 0, 0, img.width, img.height);

        // Get canvas contents as a data URL
        var imgAsDataURL = imgCanvas.toDataURL("image/png");

        // Save image into localStorage
        try {
          let StorageImage = JSON.parse(localStorage.getItem("last_used"));
          if (StorageImage.length < 4) {
            StorageImage.push(imgAsDataURL);
          } else {
            var remove = StorageImage.shift();
            StorageImage.push(imgAsDataURL);
          }
          localStorage.setItem("last_used", JSON.stringify(StorageImage));
        } catch (e) {
          console.log("Storage failed: " + e);
        }
      },
      false
    );

    await hmsActions.removePluginFromVideoTrack(previewPluginRef.current);
    previewPluginRef.current = null;
    setvbElement(img.src);
    setvb("custom");
    startPlugin(img);
  }

  async function handleRecentVB(imgSrc) {
    setShowRecent(false);
    const img = document.createElement("img");
    img.alt = "VB";
    img.src = imgSrc;
    await hmsActions.removePluginFromVideoTrack(previewPluginRef.current);
    previewPluginRef.current = null;
    setvb("recent");
    setvbElement(imgSrc);
    startPlugin(img);
    setShowRecent(false);
  }

  let getImgStorage = JSON.parse(localStorage.getItem("last_used"));
  let showOnModel = [];
  getImgStorage.forEach(img => {
    showOnModel.push(
      <img
        src={img}
        className="mt-4 h-28 w-40"
        onClick={() => handleRecentVB(img)}
      ></img>
    );
  });

  return (
    <Fragment>
      <ContextMenu
        menuOpen={showMenu}
        onTrigger={value => {
          setShowMenu(value);
        }}
        classes={{
          root: "static",
          trigger: "bg-transparent-0",
          menu: "mt-0 py-0 w-52",
        }}
        trigger={
          <Tooltip title="Virtual Background">
            <IconButton
              iconOnly
              variant="no-fill"
              iconSize="md"
              shape="rectangle"
              active={!isVBPresent}
              key="VBIcon"
            >
              <VirtualBackgroundIcon />
            </IconButton>
          </Tooltip>
        }
        menuProps={{
          anchorOrigin: {
            vertical: "top",
            horizontal: "center",
          },
          transformOrigin: {
            vertical: "bottom",
            horizontal: "center",
          },
        }}
      >
        <ContextMenuItem
          icon={<ChangeTextIcon />}
          label="Blur"
          key="blur"
          onClick={() => handleblurVB()}
        />
        <ContextMenuItem
          icon={<ChangeTextIcon />}
          label="Random"
          key="random"
          onClick={() => handleRandomVB()}
        />

        <ContextMenuItem
          icon={<ChangeTextIcon />}
          label="Recent Uploaded"
          key="lastUsed"
          onClick={() => setShowRecent(true)}
        />

        <ContextMenuItem
          icon={<ChangeTextIcon />}
          label="Upload New"
          key="upload"
          onClick={() => handleCustomVB()}
        />
        <ContextMenuItem
          icon={<ChangeTextIcon />}
          label="Disable"
          key="disable"
          onClick={() => handleDisableVB()}
        />
      </ContextMenu>
      <MessageModal
        show={showRecent}
        onClose={() => {
          setShowRecent(false);
        }}
        title="Recently Used"
        body={
          <>
            <div className="flex flex-row justify-around">{showOnModel}</div>
          </>
        }
        footer={
          <Button
            variant="emphasized"
            onClick={() => {
              handleCustomVB();
            }}
          >
            Upload New
          </Button>
        }
        classes={{
          footer: "justify-center",
          header: "mb-2",
          boxTransition: "sm:max-w-4xl",
        }}
      />
    </Fragment>
  );
};
